// Google Analytics 4 – loads only after explicit consent (granular).
export const GA_ID = 'G-BJ2WD4SN7B';
export const CONSENT_STORAGE_KEY = 'aimup_cookie_consent_v1';

export type CookieConsent = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  timestamp: string;
};

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    __aimupGaLoaded?: boolean;
  }
}

export const loadConsent = (): CookieConsent | null => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed) return null;
    return {
      necessary: true,
      analytics: !!parsed.analytics,
      marketing: !!parsed.marketing,
      timestamp: parsed.timestamp,
    };
  } catch {
    return null;
  }
};

export const saveConsent = (consent: CookieConsent) => {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
  } catch { /* ignore */ }
};

export const disableGoogleAnalytics = () => {
  try {
    (window as any)[`ga-disable-${GA_ID}`] = true;
  } catch { /* ignore */ }
};

export const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined') return;
  (window as any)[`ga-disable-${GA_ID}`] = false;
  if (window.__aimupGaLoaded) return;
  window.__aimupGaLoaded = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
};

export const trackPageView = (path: string) => {
  if (typeof window === 'undefined' || !window.__aimupGaLoaded || !window.gtag) return;
  window.gtag('config', GA_ID, { page_path: path, anonymize_ip: true });
};

/** GA4-Event – feuert nur, wenn GA (also die Analytics-Einwilligung) aktiv ist. */
export const trackGaEvent = (name: string, params?: Record<string, unknown>) => {
  if (typeof window === 'undefined' || !window.__aimupGaLoaded || !window.gtag) return;
  try {
    window.gtag('event', name, params ?? {});
  } catch {
    /* ignore */
  }
};

